import { Button, Grid, useMediaQuery, useTheme } from "@material-ui/core";
import { Delete, Edit, ExpandMore } from "@material-ui/icons";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import {
  getDateTime,
  isAdmin,
  isRoleHisReadOnly,
} from "app/common/LocalFunction";
import { useStore } from "app/stores";
import { observer } from "mobx-react";
import { memo, useState } from "react";
import { useTranslation } from "react-i18next";
import logola from "../../../../../images/logola.png";
const ListLoyaltyPoints = ({ departmentId }) => {
  const { t } = useTranslation();
  const {
    searchLoyaltyPoints,
    pageLoyaltyPoints,
    handleOpenFormCreateOrEdit,
    handleOpenConfirmDelete,
    handleFormCreateOrEdit,
    handleChangeFormSearch,
  } = useStore().patientManagementStore.loyaltyPointsStore;

  const isReadonly = isRoleHisReadOnly();
  let isAdminPermission = isAdmin();

  const [listGroup, setlistGroup] = useState({});

  const toggleListGroup = (index, boolean) => {
    setlistGroup((prevStatus) => ({
      ...prevStatus,
      [index]: boolean ? boolean : !prevStatus[index],
    }));
  };
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("xs"));
  console.log("pageLoyaltyPoints", pageLoyaltyPoints);
  return (
    <>
      <Grid container spacing={1} className="justify-center cards-body ">
        <Grid item xs={12} className="reward-history">
          <Grid container spacing={1} className="reward-history__list">
            {pageLoyaltyPoints?.content?.map((item, index) => (
              <Grid item xs={12} lg={12} className="reward-item" key={index}>
                <div className="p-2 flex justify-between w-full reward-item-wrap">
                  <div className="reward-item__left">
                    <img
                      src={
                        item?.clientAwardType?.iconDescription?.url || logola
                      }
                      alt={item?.pointRank?.name}
                    />
                  </div>

                  <div className="reward-item__middle">
                    <div className="reward-item__title flex gap-3 align-center">
                      <div>{item?.clientAwardType?.name}</div>

                      <div className="reward-item__points flex align-center gap-3 reward-item__point-group">
                        <div
                          className={`reward-item__point ${
                            item?.transactionType > 0 ? "positive" : "negative"
                          }`}
                        >
                          {item?.transactionType > 0
                            ? `+${item?.pointAmount}`
                            : `-${item?.pointAmount}`}
                        </div>

                        {item?.pointUsedAmount > 0 && (
                          <div className="reward-item__used-point">
                            -{item?.pointUsedAmount} dùng
                          </div>
                        )}

                        {item?.transactionType > 0 && (
                          <div
                            className="icon-toggle"
                            onClick={() => toggleListGroup(item?.id)}
                          >
                            {listGroup[item?.id] ? (
                              <ExpandMore color="#000" />
                            ) : (
                              <ExpandLessIcon />
                            )}
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="flex align-center justify-between">
                      <div>
                        <div className="reward-item__desc">{item?.note}</div>
                        <div className="reward-item__desc">
                          Người tạo: {item?.pointAccumulator?.staffName}
                        </div>
                        {item?.quantity != null && (
                          <div className="reward-item__desc">
                            Số lượng: {item?.quantity}
                          </div>
                        )}
                        {item?.resetPointTime != null && (
                          <div className="reward-item__desc">
                            Thời gian reset: {getDateTime(item?.resetPointTime)}
                          </div>
                        )}
                        {item?.resetPointAmount != null && (
                          <div className="reward-item__desc">
                            Số điểm reset: {item?.resetPointAmount}
                          </div>
                        )}
                        <div className="reward-item__date">
                          {getDateTime(item?.pointAccumulationTime)}
                        </div>
                      </div>
                      {
                        <ActionButton
                          handleOpenConfirmDelete={handleOpenConfirmDelete}
                          handleOpenFormCreateOrEdit={
                            handleOpenFormCreateOrEdit
                          }
                          isMobile={isMobile}
                          item={item}
                          listGroup={listGroup}
                          handleFormCreateOrEdit={handleFormCreateOrEdit}
                        />
                      }
                    </div>
                  </div>
                </div>
              </Grid>
            ))}
          </Grid>
          {pageLoyaltyPoints?.totalElements > 10 &&
            pageLoyaltyPoints?.totalElements >
              pageLoyaltyPoints?.content?.length && (
              <div
                className="see-more-btn-container"
                onClick={() => {
                  handleChangeFormSearch({
                    pageSize: +searchLoyaltyPoints?.pageSize + 10,
                  });
                }}
              >
                <button className="see-more-btn">
                  Xem thêm <span className="see-more-icon">↓</span>
                </button>
              </div>
            )}
        </Grid>
      </Grid>
    </>
  );
};

const ActionButton = ({
  listGroup,
  item,
  isMobile,
  handleOpenConfirmDelete,
  handleOpenFormCreateOrEdit,
  handleFormCreateOrEdit,
}) => {
  return (
    <div>
      {listGroup[item?.id] && (
        <div className="flex gap-2 mt-2 justify-end">
          <Button
            variant="outlined"
            startIcon={
              <Delete
                size={16}
                style={{
                  color: "#f16321",
                }}
              />
            }
            onClick={(e) => {
              e.stopPropagation();
              handleOpenConfirmDelete(item?.id);
            }}
            className="action-btn-custom"
          >
            {!isMobile && "Xóa"}
          </Button>
          <Button
            variant="outlined"
            startIcon={
              <Edit
                size={16}
                style={{
                  color: "#4276a4",
                }}
              />
            }
            className="action-btn-custom"
            onClick={(e) => {
              e.stopPropagation();
              if (!isMobile) {
                handleFormCreateOrEdit(item);
              } else {
                handleOpenFormCreateOrEdit(item);
              }
            }}
          >
            {!isMobile && "Chỉnh sửa"}
          </Button>
        </div>
      )}
    </div>
  );
};

export default memo(observer(ListLoyaltyPoints));
